(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-paf-config]').textContent);
    const button = root.querySelector('[data-paf-add]');
    const status = root.querySelector('[data-paf-status]');
    const picker = root.querySelector('.paf-picker');
    let selected = 'duffel';
    const choose = value => {
      selected = value;
      const option = config[value];
      root.querySelector('[data-paf-duffel]').hidden = value !== 'duffel';
      root.querySelector('[data-paf-backpack]').hidden = value !== 'backpack';
      root.querySelector('[data-paf-price]').textContent = option.price;
      root.querySelector('[data-paf-original]').textContent = option.original;
      root.querySelector('[data-paf-saving]').textContent = option.saving;
      root.querySelector('[data-paf-shipping]').textContent = option.shipping;
      status.textContent = '';
      button.disabled = config.enabled && !option.available;
      if (button.disabled) status.textContent = config.unavailable;
    };
    root.querySelectorAll('.paf-picker input').forEach(input => input.addEventListener('change', () => choose(input.value)));
    button.addEventListener('click', async () => {
      if (!config.enabled) { status.textContent = config.previewMessage; return; }
      const option = config[selected];
      if (!option.available) { status.textContent = config.unavailable; return; }
      button.disabled = true;
      picker.disabled = true;
      status.textContent = config.adding;
      try {
        const response = await fetch(config.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: option.id, quantity: 1 }] }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || config.errorMessage);
        window.location.assign(config.root + 'cart');
      } catch (error) {
        status.textContent = error.message || config.errorMessage;
        button.disabled = false;
        picker.disabled = false;
      }
    });
    choose(selected);
  };
  document.querySelectorAll('[data-paf-root]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-paf-root]').forEach(initialize));
})();
